
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"16","height":"16","x":".5","y":".5","fill":"#fff","stroke":"#CDCDCD","rx":"1.5"}}),_c('path',{attrs:{"fill":"#000","d":"M10.209 4.548c.401-.502.673-1.176.601-1.865-.587.03-1.304.388-1.719.89-.372.43-.702 1.132-.616 1.792.66.057 1.318-.33 1.734-.817M10.803 5.494c-.957-.057-1.772.543-2.229.543s-1.158-.514-1.915-.5c-.986.014-1.9.571-2.4 1.458-1.03 1.773-.272 4.404.728 5.848.486.714 1.072 1.501 1.843 1.473.73-.029 1.015-.472 1.901-.472s1.143.472 1.915.458c.8-.015 1.3-.715 1.786-1.43.558-.815.786-1.602.8-1.645-.014-.014-1.543-.6-1.557-2.36-.014-1.472 1.2-2.172 1.257-2.215-.686-1.015-1.757-1.13-2.129-1.158"}})])
          )
        }
      }
    